import { styled } from "styled-components";
import { Colors } from "../constants";
import { useState, useEffect } from "react";
import Encounters from "../encounters";
import { Header, Paragraph } from "../constants";
import Button from "./Button";
import { motion } from "framer-motion";
import Headline from "./Headline";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 800px) {
    height: auto;
  }
`;

const SheetWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 32px 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 800px) {
    padding: 0 16px 16px;
  }
`;

const EncounterSheet = styled(motion.div)`
  width: 100%;
  height: 100%;
  max-width: 1024px;
  display: flex;
  flex-direction: row;
  background: ${Colors.Tan};
  border-radius: 32px;
  padding: 32px;
  gap: 32px;
  flex: 1;
  @media (max-width: 800px) {
    border-radius: 16px;
    flex-direction: column-reverse;
    gap: 8px;
    padding: 0;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  @media (max-width: 800px) {
    border-top: 1px solid ${Colors.TanShadow};
    padding: 16px;
  }
`;

const RollColumn = styled(Column)`
  gap: 16px;
  border: none;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-direction: 8px;
`;

const NewEncounterButton = styled(motion.div)`
  font-size: 14px;
  line-height: 100%;
  height: 48px;
  min-height: 48px;
  font-family: "Space Grotesk", sans-serif;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  padding: 0 48px;
  text-align: center;
`;

const BackButton = styled(NewEncounterButton)``;

const NavRow = styled.div`
  display: flex;
  flex-direction: horizontal;
  min-height: 48px;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1024px;
`;

const EncounterGenerator = ({ roll, rollDie }) => {
  const [encounter, setEncounter] = useState(null);

  const getEncounter = (rawEncounter) => {
    setEncounter(rawEncounter);
  };

  useEffect(() => {
    if (encounter === null) {
      const randomEncounter =
        Encounters[Math.floor(Math.random() * Encounters.length)];
      getEncounter(randomEncounter);
    }
  });

  return (
    <Wrapper>
      <NavRow>
        <BackButton
          onClick={() => window.location.reload()}
          initial={{ scale: 1, color: Colors.Tan }}
          whileHover={{ scale: 1.05, color: Colors.Tan }}
          whileTap={{ scale: 0.95, color: Colors.Tan }}
          transition={{ type: "ease-out", duration: 0.25 }}
        >
          Back
        </BackButton>
        <NewEncounterButton
          onClick={() =>
            getEncounter(
              Encounters[Math.floor(Math.random() * Encounters.length)]
            )
          }
          initial={{ scale: 1, color: Colors.Tan }}
          whileHover={{ scale: 1.05, color: Colors.Tan }}
          whileTap={{ scale: 0.95, color: Colors.Tan }}
          transition={{ type: "ease-out", duration: 0.25 }}
        >
          Get a new encounter
        </NewEncounterButton>
      </NavRow>
      {encounter !== null && (
        <>
          <Headline title={encounter.name} roll={roll} />
          <SheetWrapper>
            <EncounterSheet
              initial={{ opacity: 0, translateY: 20 }}
              animate={{ opacity: 1, translateY: 0 }}
              transition={{ type: "ease-out", duration: 0.25 }}
            >
              <Column>
                <Section>
                  <Header>Encounter name</Header>
                  <Paragraph>{encounter.name}</Paragraph>
                </Section>
                <Section>
                  <Header>Description</Header>
                  <Paragraph>{encounter.description}</Paragraph>
                </Section>
                <Section>
                  <Header>Points of interest</Header>
                  {encounter.pointsOfInterest.map((point) => (
                    <Paragraph>{point}</Paragraph>
                  ))}
                </Section>
              </Column>
              <RollColumn>
                <Button onClick={() => rollDie("", 0)}>Roll a d20</Button>
                {encounter.rolls.map((encRoll) => (
                  <Button onClick={() => rollDie(encRoll.name, encRoll.bonus)}>
                    {encRoll.name + " (+" + encRoll.bonus + ")"}
                  </Button>
                ))}
              </RollColumn>
            </EncounterSheet>
          </SheetWrapper>
        </>
      )}
    </Wrapper>
  );
};

export default EncounterGenerator;
